import styled, { css } from 'styled-components';
import { Icon, Modal } from 'src/components';
import { Header, MainStripe } from '../styles';

const SidebarComponent = ({ ...props }: Parameters<typeof Modal>[0]) => (
  <Modal {...props} fullSize hideCloseButton />
);
export const Sidebar = styled(SidebarComponent)(
  ({ theme }) => css`
    .reactModalOverlay {
      justify-content: flex-end;
    }

    .reactModalContent {
      max-width: ${theme.sz.ms};
      background-color: ${theme.co.primary30};
    }
  `,
);

export const SidebarContent = styled.div(
  () => css`
    overflow-x: auto;
    height: 100%;
  `,
);

export const SidebarHeader = styled(Header)(() => css``);
export const SidebarMainStripe = styled(MainStripe)(() => css``);

export const CloseButtonWrapper = styled.div(
  ({ theme }) => css`
    height: ${theme.sz.s12};
  `,
);

export const CloseButton = styled.button(
  ({ theme }) => css`
    color: ${theme.co.neutral99};
    background: none;
    padding: ${theme.sz.s0};
    border: none;
    cursor: pointer;
    height: ${theme.sz.s12};
    width: ${theme.sz.s12};
  `,
);

const CrossIcon = ({ ...props }) => <Icon {...props} name="crossNew" useCurrentColor />;
export const CloseIcon = styled(CrossIcon)(
  ({ theme }) => css`
    svg {
      height: 100%;
      width: 100%;
      padding: ${theme.sz.s0} calc(100% * 10 / 48);
    }
  `,
);

export const Navigation = styled.nav(
  ({ theme }) => css`
    padding: ${theme.sz.s6} ${theme.sz.s4};
  `,
);

export const NavigationList = styled.ul(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s2};
    margin: ${theme.sz.s0};
    padding: ${theme.sz.s0};
    ${theme.typography.heading.desktop.xxxs};
  `,
);

export const NavigationListItem = styled.li(
  ({ theme }) => css`
    list-style-type: none;
    display: flex;
    flex-direction: column;
    min-height: ${theme.sz.s8};
    justify-content: center;

    // We need this as on mobile devices the bottom content is hidden
    // under the browser toolbar
    &:last-of-type {
      margin-bottom: ${theme.sz.s18};
    }
  `,
);

export const NavigationLink = styled.a(
  ({ theme }) => css`
    display: inline-block;
    color: inherit;
    text-decoration: none;
    transition: transform 0.5s ease;

    &:hover {
      transform: translateY(-${theme.sz.s05});
    }
  `,
);
